__turbopack_context__.v({
  "kbd": "Kbd-module__Ve-YtW__kbd",
});
